import { SET_USER, LOGOUT_USER,CHANGE_WINDOW, CHANGE_BALANCE, SET_PERMISSIONS,FORCE_LOGOUT_USER, SET_ANONYMOUS_USER } from '../actionsList';

const initialSettings = {
    loggedin: false,
    info: {},
    anonymousInfo:{},
    windows:{}
    
};

const userReducer = (state = initialSettings, action) => {
    switch (action.type) {
        case SET_USER:
            return {
                ...state,
                loggedin: (action.loggedin != null) ? action.loggedin : state[action.loggedin],
                role: (action.role != null) ? action.role : state[action.role],
                info: action.info,
                
            }
            
        case SET_ANONYMOUS_USER:
            return {
                ...state,
                anonymousInfo: action.info,
            }

        case SET_PERMISSIONS: {
            let info = state.info
            if (!info) {
                info = {}
            }
            if (!info.permissions) {
                info.permissions = {}
            }
            if (!info.permissions[action.applet]) {
                info.permissions[action.applet] = {}
            }
            let appletFullAccess = false
            let collectionFullAccess = false
            let automationFullAccess = false
            let userPrespectiveFullAccess = false
            action.permissions.forEach(element => {
                // if (element.type == 'admin') {
                //     if (element.byAppletAccess) {
                        
                //     }
                //     info.permissions[action.applet].applet = element.permissions
                //     let fullAccess = false
                //     if (connections[i].applet == applet) {
                //         console.log(connections[i].roots)
                //         for (let y = 0; y < connections[i].roots.length; y++) {
                //             for (let x = 0; x < connections[i].roots[y].permissions.length; x++) {

                //                 // if (!connections[i].newPermissionss[applet]) { 
                //                 //     connections[i].newPermissionss[applet] = []
                //                 // }
                //                 if (connections[i].roots[y].permissions[x].permission.newPermissions == '*') {
                //                     newPermissions[applet] = '*'
                //                     console.log('acscs', applet)
                //                     fullAccess = true
                //                     // return
                //                 }
                //                 else if (!fullAccess && connections[i].roots[y].permissions[x].permission.newPermissions) {
                //                     for (const [pKey, pValue] of Object.entries(connections[i].roots[y].permissions[x].permission.newPermissions)) {
                //                         if (!newPermissions[applet][pKey]) {
                //                             newPermissions[applet][pKey] = pValue
                //                         }
                //                     }
                //                 }
                //             }
                //         }
                //     }
                //     if (fullAccess) {
                //         newPermissions[applet] = '*'
                //     }
                // }
                // else if (element.type == 'collection') {

                // }
                // else if (element.type == 'automation') {

                // }
                // else if (element.type == 'public') {

                // }
            });

            // info.permissions[action.applet] = action.permissions[action.applet]
            // console.log('info.permiso2', info.permissions)
            // action.permissions[]
            return {
                ...state,
                info
            }


        }
        case LOGOUT_USER:
            // console.log('hereactiomlog', action)

            return {
                ...state,
                loggedin: false,
                info: {},
                windows:{}
            }

            
        case FORCE_LOGOUT_USER:
            // console.log('hereactiomforc', action)

            return {
                ...state,
                loggedin: false,
                info: {},
                // windows:{}
            }

            
        case CHANGE_WINDOW:
            // console.log('hereactiom', action.window)
            
            return {
                ...state,
                windows: action.window
            }

        case CHANGE_BALANCE:

            return {
                ...state,
                info: {
                    balance: action.data.balance,
                    selfBalance: action.data.selfBalance
                }
            }

        default:
            return state;
    }
}






export default userReducer;